<template>
    <v-container>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">MIS CONTACTOS</v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="getReceivers">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md="12">
                <v-card>
                    <v-card-title>
                        <v-btn color="primary" large block @click="addReceiver = true">
                            <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;Nuevo Contacto
                        </v-btn>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details/>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading"
                                  :no-data-text="noDataText" :footer-props="footerProps">
                        <template v-slot:item.name="{ item }">
                            <span style="text-transform: capitalize">{{ item.name ? (item.name).toLowerCase() : '' }}</span>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" small depressed class="ma-1" title="Editar" @click="edit(item.id)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn color="error" small depressed class="ma-1" title="Borrar" @click="trash(item.id)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card class="mt-4">
                    <v-card-title>
                        <span class="subtitle-1 font-weight-bold">Favoritos wallet</span>
                        <v-spacer/>
                        <v-btn color="primary" small depressed @click="openWalletContact">
                            <v-icon left>mdi-star-plus</v-icon> Agregar
                        </v-btn>
                    </v-card-title>
                    <v-data-table
                        :headers="walletHeaders"
                        :items="walletContacts"
                        :loading="walletContactLoading"
                        no-data-text="No tienes favoritos wallet registrados"
                        :footer-props="footerProps">
                        <template v-slot:item.nickname="{ item }">
                            <span class="font-weight-bold primary--text">{{ item.nickname }}</span>
                        </template>
                        <template v-slot:item.name="{ item }">
                            <span>{{ item.alias || item.name || item.label }}</span>
                        </template>
                        <template v-slot:item.verified="{ item }">
                            <v-chip x-small :color="item.verified ? 'success' : 'warning'" text-color="white">
                                {{ item.verified ? 'Verificado' : 'Sin verificar' }}
                            </v-chip>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn color="error" small depressed class="ma-1" title="Borrar" @click="trashWalletContact(item.id)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
                <v-dialog v-model="addReceiver" n fullscreen hide-overlay transition="dialog-bottom-transition">
                    <add v-on:close-add="closeAdd" @success="getReceivers"/>
                </v-dialog>
                <v-dialog v-model="editReceiver" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <edit v-on:close-edit="closeEdit" :receiver="receiver" @success="getReceivers"/>
                </v-dialog>
                <v-dialog v-model="walletContactDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-form ref="walletContactForm" v-model="walletContactValid" @submit.prevent="saveWalletContact">
                            <v-progress-linear indeterminate fixed v-if="walletContactLoading" style="top:0"/>
                            <v-toolbar dark color="primary">
                                <v-btn class="ml-1" icon dark @click="closeWalletContact">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-spacer/>
                                <v-toolbar-title class="secondary--text text-center font-weight-bold text-uppercase">Favorito Wallet</v-toolbar-title>
                                <v-spacer/>
                                <v-toolbar-items>
                                    <v-btn dark text type="submit" :loading="walletContactLoading" :disabled="walletContactLoading || !walletContactValid">Guardar</v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-card-text>
                                <v-container>
                                    <v-row justify="center">
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="walletContactForm.nickname"
                                                label="Nickname destino"
                                                prefix="$"
                                                prepend-icon="mdi-account-cash"
                                                :rules="[rules.required]"
                                                @input="walletContactForm.nickname = cleanNickname(walletContactForm.nickname)"/>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="walletContactForm.alias"
                                                label="Alias"
                                                prepend-icon="mdi-account-star"
                                                hint="Opcional"
                                                persistent-hint/>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-checkbox
                                                v-model="walletContactForm.is_favorite"
                                                label="Marcar como favorito"
                                                prepend-icon="mdi-star"
                                                hide-details/>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Add from "./receivers/Add";
    import Edit from "./receivers/Edit";

    export default {
        name: "Receivers",
        components: { Add, Edit },
        props: [ 'user' ],
        data: () => ({
            search: '',
            headers: [
                { text: 'Nombres', value: 'name' },
                { text: 'Documento', value: 'document' },
                { text: 'Detalle', value: 'bank_details' },
                { text: 'Moneda', value: 'currency' },
                { text: 'País', value: 'country_text' },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            walletHeaders: [
                { text: 'Nickname', value: 'nickname' },
                { text: 'Nombre/Alias', value: 'name' },
                { text: 'Estado', value: 'verified', align: 'center' },
                { text: 'Último pago', value: 'last_paid_at' },
                { text: 'Acción', value: 'action', align: 'center', filterable: false, sortable: false }
            ],
            desserts: [],
            walletContacts: [],
            expanded: [],
            loading: true,
            walletContactLoading: false,
            noDataText: 'No tienes contactos registrados',
            expandIcon: 'mdi-chevron-down-circle',
            footerProps: {
                itemsPerPageOptions: [25, 50, 100, 250, -1]
            },
            addReceiver: false,
            editReceiver: false,
            receiver: null,
            walletContactDialog: false,
            walletContactValid: true,
            walletContactForm: {
                nickname: '',
                alias: '',
                is_favorite: true
            },
            rules: {
                required: v => !!v || 'Campo obligatorio.'
            }
        }),
        created () {
            this.getReceivers();
            this.getWalletContacts();
        },
        methods: {
            getReceivers(v) {
                clearTimeout(this.timeout);
                if (v === 1) {
                    this.loading = true;
                }
                axios.get('/api/receivers').then((res) => {
                    this.desserts = res.data.items;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
                this.timeout = setTimeout(this.getReceivers, 150000);
            },
            getWalletContacts() {
                this.walletContactLoading = true;
                axios.get('/api/wallet/contacts').then((res) => {
                    this.walletContacts = res.data.contacts || [];
                }).catch(err => {
                    const msg = err.response && err.response.data && err.response.data.status ? err.response.data.status : 'No fue posible cargar favoritos wallet.';
                    this.$toast.error(msg, { icon: 'mdi-alert-circle' });
                }).then(() => {
                    this.walletContactLoading = false;
                });
            },
            closeAdd() {
                this.addReceiver = false;
                this.receiver = null;
            },
            closeEdit() {
                this.editReceiver = false;
                this.receiver = null;
            },
            edit(id) {
                this.receiver = id;
                this.editReceiver = true;
            },
            openWalletContact() {
                this.walletContactDialog = true;
                this.walletContactForm = {
                    nickname: '',
                    alias: '',
                    is_favorite: true
                };
                this.$nextTick(() => {
                    if (this.$refs.walletContactForm) {
                        this.$refs.walletContactForm.resetValidation();
                    }
                });
            },
            closeWalletContact() {
                this.walletContactDialog = false;
            },
            cleanNickname(value) {
                return String(value || '').trim().replace(/^\$/, '').toUpperCase();
            },
            saveWalletContact() {
                if (!this.$refs.walletContactForm || !this.$refs.walletContactForm.validate()) return;

                this.walletContactLoading = true;
                axios.post('/api/wallet/contacts', {
                    nickname: this.cleanNickname(this.walletContactForm.nickname),
                    alias: this.walletContactForm.alias,
                    is_favorite: this.walletContactForm.is_favorite
                }).then(res => {
                    this.$toast.success(res.data.status, { icon: 'mdi-star-check' });
                    this.closeWalletContact();
                    this.getWalletContacts();
                }).catch(err => {
                    const msg = err.response && err.response.data && err.response.data.status ? err.response.data.status : 'No fue posible guardar el favorito wallet.';
                    this.$toast.error(msg, { icon: 'mdi-alert-circle' });
                }).then(() => {
                    this.walletContactLoading = false;
                });
            },
            trashWalletContact(id) {
                this.$swal({
                    title: '¿Esta seguro de eliminar este favorito wallet?',
                    type: 'warning',
                    confirmButtonText: 'Si, eliminar',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        axios.delete('/api/wallet/contacts/' + id).then(res => {
                            this.$toast.success(res.data.status, { icon: 'mdi-delete' });
                            this.getWalletContacts();
                        }).catch(err => {
                            const msg = err.response && err.response.data && err.response.data.status ? err.response.data.status : 'No fue posible eliminar el favorito wallet.';
                            this.$toast.error(msg, { icon: 'mdi-alert-circle' });
                        });
                    }
                });
            },
            trash(id) {
                this.$swal({
                    title: '¿Esta seguro de eliminar esta cuenta?',
                    type: 'warning',
                    confirmButtonText: 'Si, eliminar',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/receivers/delete/' + id)
                            .then(res => {
                                if (res.data.v === 'success') {
                                    this.getReceivers();
                                    this.$swal({
                                        title: '¡Eliminado!',
                                        text: 'La cuenta se ha eliminado exitosamente',
                                        type: 'success',
                                        showConfirmButton: false,
                                        cancelButtonText: 'Cerrar',
                                        timer: 5000
                                    });
                                } else {
                                    this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                                }
                            })
                            .catch(err => {
                                this.handleErrors(err.response.data.errors);
                            })
                    }
                })
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
